module.exports = __webpack_public_path__ + "components/promo-premium/static/premium-bg-b9dcb3fdb6abcd61f2adc294503f0585.jpg";